// lock-body-scroll.directive.ts
import { Directive, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appLockBodyScroll]'
})
export class LockBodyScrollDirective implements OnInit, OnDestroy {
  private static openCount = 0;

  ngOnInit(): void {
    LockBodyScrollDirective.openCount++;
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    LockBodyScrollDirective.openCount = Math.max(0, LockBodyScrollDirective.openCount - 1);
    if (LockBodyScrollDirective.openCount === 0) {
      document.body.style.overflow = '';
    }
  }
}
